<template>
  <section class="card">
    <header class="header-card">
      <p> {{ $t('editionFormatAffiche.etapeInformation.title') }} </p>
    </header>
    <div class="card-content">
      <table class="VueTables__table table is-bordered is-fullwidth">
        <thead>
          <th class="colonne-responsive">
            {{ $t('editionFormatAffiche.fields.visuel') }}
          </th>
          <th class="colonne-responsive">
            {{ $t('editionFormatAffiche.fields.impression') }}
          </th>
          <th class="colonne-responsive">
            {{ $t('editionFormatAffiche.fields.faconnage') }}
          </th>
          <th class="colonne-responsive">
            {{ $t('editionFormatAffiche.fields.expedition') }}
          </th>
        </thead>
        <tbody>
          <tr>
            <td> <etape-information :data="formatAffiche.visuel" :detail="detail" /> </td>
            <td> <etape-information :data="formatAffiche.impression" :detail="detail" /> </td>
            <td> <etape-information :data="formatAffiche.faconnage" :detail="detail" /> </td>
            <td> <etape-information :data="formatAffiche.expedition" :detail="detail" /> </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import EtapeInformation from '@/components/parametrage/formatAffiche/etapeInformation';

export default {
  name: 'EtapeInformationEditDetail',
  components: {
    EtapeInformation,
  },
  props: {
    formatAffiche: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
